<script setup>
import TitleAlertSaveImport from '@/components/common/TitleAlertSaveImport.vue'
import ImportFileStepper from '@/components/common/ImportFileStepper.vue'
import SettlementTable from './SettlementTable.vue'
import DownloadDialog from '@/components/common/DownloadDialog.vue'
import BoundaryConditionWarning from './BoundaryConditionWarning.vue'
import BoundaryConditionAlert from '@/components/boundary-condition/BoundaryConditionAlert.vue'
import { boundaryConditionMixin } from '@/mixins/boundaryConditionMixin'
import { onMounted, ref } from 'vue'

const STORE_NAMESPACE = 'settlement'
const settlement = ref(null)

const {
  dialog,
  downloadDialog,
  exportDialog,
  writeLoading,
  fetchLoading,
  count,
  downloadLoading,
  exportLoading,
  items,
  importItems,
  ignoredReferencePoint,
  importItemCount,
  loading,
  templateFileName,
  exportFileName,
  years,
  importedYears,
  addNewItem,
  fetchYears,
  fetchAvailableReferencePoints,
  fetchOptions,
  changePaginatedPage,
  downloadTemplate,
  exportData,
  saveChanges
} = boundaryConditionMixin(STORE_NAMESPACE, settlement)

onMounted(async () => {
  fetchLoading.value = true
  await fetchYears()
  await fetchAvailableReferencePoints()
  await fetchOptions()
  fetchLoading.value = false
})
</script>

<template>
  <v-card style="min-height: 8px" :loading="loading" variant="flat" rounded="0">
    <template #loader="{ isActive }">
      <v-progress-linear :active="isActive" indeterminate color="primary" class="mx-1" />
    </template>
    <BoundaryConditionAlert
      v-if="!loading && !count"
      type="settlement"
      @import="dialog = true"
      @download="downloadDialog = true"
    />
    <div v-else>
      <SettlementTable
        ref="settlement"
        @changePage="changePaginatedPage"
        :items="items"
        :count="count"
        :years="years"
      >
        <template v-slot>
          <TitleAlertSaveImport
            v-if="!loading"
            export-text="data export"
            import-text="data import"
            download-text="template"
            @add="addNewItem"
            @save="saveChanges()"
            :loading-save="writeLoading"
            @import="dialog = true"
            :download-button="true"
            @download="downloadDialog = true"
            :export-button="true"
            @export="exportDialog = true"
          />
        </template>
      </SettlementTable>
    </div>
    <v-dialog v-model="dialog" max-width="85%">
      <ImportFileStepper
        @close-dialog="dialog = false"
        :storeNamespace="STORE_NAMESPACE"
        text="settlement data"
      >
        <template v-slot>
          <BoundaryConditionWarning :ignored-reference-point="ignoredReferencePoint" />
          <SettlementTable
            :items="importItems"
            :count="importItemCount"
            :years="importedYears"
            :editable="false"
          />
        </template>
      </ImportFileStepper>
    </v-dialog>
    <DownloadDialog
      @update:dialog="downloadDialog = $event"
      :dialog="downloadDialog"
      width="500"
      :file-name="templateFileName"
      :loading="downloadLoading"
      text="Download settlement data template"
      @download="downloadTemplate()"
    ></DownloadDialog>
    <DownloadDialog
      @update:dialog="exportDialog = $event"
      :dialog="exportDialog"
      width="500"
      :file-name="exportFileName"
      :loading="exportLoading"
      text="Export settlement data"
      @download="exportData()"
    ></DownloadDialog>
  </v-card>
</template>
